import React from "react"
import { CHOOSE_THE_RIGHT_CARE_HOME_URL } from "../../../../../utils/paths"
import ChooseCareLink from "./ChooseCareLink"

import {
  careTypeParagraphCopy,
  careTypeTitleCopy,
  positivelyRatedParagraphCopy,
} from "./shared"

import { dementiaCareHomeQA } from "./care_home_towns/dementia-care-homes"
import { averageCareHomeCostAnswer } from "./care_home_towns/average-care-home-costs"
import { localFundingQA } from "./care_home_towns/local-funding"

const careHomeIntroText = (locationName, totalCareHomeCount) =>
  totalCareHomeCount === 1
    ? `There is 1 care home in ${locationName}`
    : `There are ${totalCareHomeCount} care homes in ${locationName}`

export default ({
  locationName,
  totalCareHomeCount,
  careType,
  regulatoryBody,
  positivelyRatedCount,
  dementiaCareHomeCount,
  branchRecords,
  geographicScale,
}) => [
  {
    question: `How many care homes are there in ${locationName}?`,
    answer: (
      <>
        {careHomeIntroText(locationName, totalCareHomeCount)} offering a range
        of specialisms. If you’re not sure which type of care home is best for
        you, you can read our guide on <ChooseCareLink />.
      </>
    ),
    // eslint-disable-next-line max-len
    structuredDataAnswer: `${careHomeIntroText(
      locationName,
      totalCareHomeCount,
      // eslint-disable-next-line max-len
    )} offering a range of specialisms. If you’re not sure which type of care home is best for you, you can read our guide on <a href=${CHOOSE_THE_RIGHT_CARE_HOME_URL}>how to choose the right care home</a>.`,
  },
  {
    question: careTypeTitleCopy(careType, locationName),
    answer:
      totalCareHomeCount === 1
        ? `${careTypeParagraphCopy(careType, locationName, regulatoryBody)}`
        : `${careTypeParagraphCopy(
            careType,
            locationName,
            regulatoryBody,
          )} ${positivelyRatedParagraphCopy(
            "care homes",
            locationName,
            totalCareHomeCount,
            positivelyRatedCount,
          )}.`,
  },
  dementiaCareHomeCount > 0 &&
    dementiaCareHomeQA(
      locationName,
      dementiaCareHomeCount,
      branchRecords,
      geographicScale,
    ),
  {
    question: `How much do care homes in ${locationName} cost?`,
    answer: averageCareHomeCostAnswer(branchRecords, locationName),
  },
  {
    question:
      "What is the difference between nursing homes and residential care homes?",
    answer:
      "Residential care homes provide residents with accommodation, meals, and assistance with personal care and medication.  " +
      "However, a nursing care home will also provide medical care from a qualified nurse, including treatment for any illness or injuries.",
  },
  localFundingQA(regulatoryBody, locationName),
]
